import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { mobile } from '../responsive';
import NonImage from '../Images/image.png';
import { useDispatch } from 'react-redux';
import { setLoading, resetLoading } from '../redux/loadingSlice';
import { activateCourse } from '../redux/httpRequests';
import privateRequest from '../api/axios';
import { getStorage, ref, uploadBytesResumable, getDownloadURL } from "firebase/storage";
import app from '../services/firebase';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import VideoCallIcon from '@mui/icons-material/VideoCall';
import CheckIcon from '@mui/icons-material/Check';
import * as tus from 'tus-js-client';
// actualiza
const Container = styled.div`
  width: 80vw; height: 82vh; padding: 30px; display: flex; gap: 2vw;
  ${mobile({marginTop: '90px', width:'95vw', height:'auto'})}
`;
const Wrapper = styled.div`
  height: 100%; width: 55vw; display: flex; gap: 2vw; position: relative;
  box-shadow: 0 0 10px 2px rgba(161,161,161,.61); border-radius: 10px;
  ${mobile({width: '100%', flexDirection:'column', padding:'12px'})}
`;
const Wrapper2 = styled.div`
  height: 100%; width: 20vw; display: flex; gap: 2vw; position: relative;
  box-shadow: 0 0 10px 2px rgba(161,161,161,.61); border-radius: 10px;
  ${mobile({width:'100%', marginTop:'16px'})}
`;
const Left = styled.div` flex:1; display:flex; flex-direction:column; margin: 8vh 0 8vh 2vw; gap:2vh; `;
const Right = styled.div` flex:1; display:flex; flex-direction:column; margin: 8vh 2vw 8vh 0; gap:2vh; `;
const InputContainer = styled.div` display:flex; flex-direction:column; align-items:center; width:100%; `;
const Input = styled.input`
  border:none; border-bottom:1px solid gray; text-align:center; width:80%; padding:5px;
  &:focus{ outline:none; border-bottom:2px solid #216E8C; }
`;
const Label = styled.label` width:100%; display:flex; justify-content:center; align-items:center; `;
const ThumbContainer = styled.div` display:flex; justify-content:center; align-items:center; width:80%; height:100%; `;
const Thumbnail = styled.img`
  max-height: 36vh; max-width: 30vw; border:1px solid #216E8C; border-radius:5px; object-fit:cover; cursor:pointer;
  ${mobile({maxWidth:'90vw'})}
`;
const ThumbnailLabel = styled.label` cursor:pointer; `;
const ThumbnailInput = styled.input` display:none; `;
const VideoInputContainer = styled.div`
  display:flex; background: rgba(33,110,140,0.05); border:1px solid lightgray; border-bottom:none; width:100%; height:6vh; cursor:pointer; position:relative;
  &:hover{ background: rgba(33,110,140,0.6); color:#fff; }
`;
const VideoInput = styled.input` display:none; `;
const PdfsLabel = styled.label`
  display:flex; justify-content:center; align-items:center; gap:1vw; padding:1vh 2vw; border:1px solid #e72020; border-radius:5px; cursor:pointer;
  &:hover{ background:#e72020; color:#fff; }
`;
const AddPdfsButton = styled.input` display:none; `;
const AddVideoButton = styled.button`
  display:flex; justify-content:center; align-items:center; gap:1vw; padding:1vh 2vw; border:none; border-radius:5px; cursor:pointer;
`;
const UploadVideoButton = styled.button`
  display:flex; justify-content:center; align-items:center; gap:1vw; padding:1vh 2vw; border:none; border-radius:5px; background:#216E8C; color:#fff; font-weight:600; cursor:pointer;
  &:hover{ background:transparent; color:#216E8C; border:1px solid #216E8C; }
`;

export default function CourseNew() {
  const dispatch = useDispatch();

  const [files, setFiles] = useState([]);           // videos
  const [cover, setCover] = useState(null);         // thumbnail
  const [pdfFiles, setPdfFiles] = useState([]);     // pdfs
  const [courses, setCourses] = useState([]);       // listado preview (opcional)
  const [courseData, setCourseData] = useState({
    title: undefined, description: undefined, duration: undefined, price: undefined, dolarPrice: undefined,
  });
  const [formError, setFormError] = useState({ set:false, message:'' });

  const getCourses = async () => {
    try {
      const res = await privateRequest.get("/courses/courses-admin");
      setCourses(res.data || []);
    } catch (err) { console.log(err); }
  };
  useEffect(() => { getCourses(); }, []);
  useEffect(() => { setFormError({set:false,message:''}); }, [courseData, cover, pdfFiles, files]);

  const addInput = () => { if (files.length < 15) setFiles([...files, null]); };
  const onFileChange = (e, idx) => { const f = e.target.files?.[0]; const next = [...files]; next[idx] = f; setFiles(next); };
  const onCoverChange = (e) => setCover(e.target.files?.[0] || null);
  const onPdfsChange = (e) => setPdfFiles(Array.from(e.target.files || []));
  const onChange = (e) => setCourseData(prev => ({ ...prev, [e.target.name]: e.target.value }));

  const valueCheck = () => Object.values(courseData).includes(undefined);

  // const uploadThumbnailFirebase = async () => {
  //   if (!cover) return null;
  //   const storage = getStorage(app);
  //   const fileName = `${Date.now()}_${cover.name}`;
  //   const storageRef = ref(storage, fileName);
  //   const uploadTask = uploadBytesResumable(storageRef, cover);
  //   const url = await new Promise((resolve, reject) => {
  //     uploadTask.on('state_changed', () => {}, reject, () => {
  //       getDownloadURL(uploadTask.snapshot.ref).then(resolve).catch(reject);
  //     });
  //   });
  //   return url; // url pública
  // };

  const uploadPdfsToServer = async () => {
    if (!pdfFiles?.length) return [];
    const formData = new FormData();
    pdfFiles.forEach((f) => formData.append('pdfs', f));
    const res = await privateRequest.post('/upload/pdfs', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
    return res.data?.uploadedPdfsPath || [];
  };


  const uploadThumbnailImageKit = async () => {
    if (!cover) return null;

    // 1) pedir firma al backend (ruta autenticada)
    const authRes = await privateRequest.get("/upload/imagekit-auth");
    const { token, expire, signature, publicKey } = authRes.data;

    // 2) subir directo a ImageKit
    const form = new FormData();
    form.append("file", cover);
    form.append("fileName", `${Date.now()}_${cover.name}`);
    form.append("folder", "/courses/thumbnails");
    form.append("publicKey", publicKey);
    form.append("token", token);
    form.append("expire", String(expire));
    form.append("signature", signature);

    const res = await fetch("https://upload.imagekit.io/api/v1/files/upload", {
      method: "POST",
      body: form,
    });

    if (!res.ok) {
      const text = await res.text();
      throw new Error(`ImageKit upload failed: ${res.status} ${text}`);
    }

    const json = await res.json();
    return json.url; // ✅ igual que Firebase: URL pública
  };

  // const uploadSingleVideo = async (file) => {
  //   const formData = new FormData();
  //   formData.append('videoFiles', file);
  //   const res = await privateRequest.post('/courses/tutorial', formData, {
  //     headers: { 'Content-Type': 'multipart/form-data' },
  //   });
  //   const keys = res.data || [];
  //   return keys[0];
  // };

  // V2
  // const uploadSingleVideo = async (file) => {
  //   const formData = new FormData();
  //   formData.append('videoFiles', file);

  //   try {
  //     console.log('TOKEN?', privateRequest.defaults.headers?.common?.Authorization);
  //     const res = await privateRequest.post('/courses/tutorial', formData, {
  //       // NO pongas Content-Type a mano, axios lo arma con boundary
  //       onUploadProgress: (e) => {
  //         if (!e.total) return;
  //         const pct = Math.round((e.loaded * 100) / e.total);
  //         console.log(`[UPLOAD] ${file?.name} ${pct}%`);
  //       },
  //       timeout: 0, // para que no corte por timeout de axios (si tenés alguno global)
  //     });

  //     const keys = res.data || [];
  //     return keys[0];
  //   } catch (err) {
  //     console.log('[UPLOAD ERROR]', {
  //       status: err?.response?.status,
  //       data: err?.response?.data,
  //       msg: err?.message,
  //     });
  //     throw err;
  //   }
  // };

  const uploadSingleVideo = async (file) => {
    // 1) backend crea el video y te da upload_link + player_embed_url
    const { data } = await privateRequest.post('/courses/tutorial/create-upload', {
      size: file.size,
      name: file.name,
    });

    const { upload_link, player_embed_url } = data;

    // 2) subís directo a Vimeo (TUS)
    await new Promise((resolve, reject) => {
      const upload = new tus.Upload(file, {
        uploadUrl: upload_link,
        retryDelays: [0, 1000, 3000, 5000, 10000],
        chunkSize: 8 * 1024 * 1024,
        removeFingerprintOnSuccess: true,
        fingerprint: async (f) => `${f.name}-${f.size}-${f.lastModified}`,
        storeFingerprintForResuming: false, // (opcional para test en incógnito)
        metadata: {
          filename: file.name,
          filetype: file.type || 'video/mp4',
        },
        onError: (error) => reject(error),
        onProgress: (bytesUploaded, bytesTotal) => {
          const pct = Math.round((bytesUploaded / bytesTotal) * 100);
          console.log(`[UPLOAD] ${file.name} ${pct}%`);
        },
        onSuccess: () => resolve(true),
      });

      upload.start();
    });

    // 3) ✅ devolvés exactamente lo mismo que antes guardabas en urls
    return player_embed_url;
  };

  const saveVideoInfo = async (payload) => {
    const res = await privateRequest.post('/courses/saveInfo', payload);
    return res.data?.savedCourse; // { _id, ... }
  };

  const handleCreateCourse = async (e) => {
    e.preventDefault();
    if (valueCheck() || !cover || !files.length || !pdfFiles.length) {
      return setFormError({ set:true, message:'Faltan campos requeridos en tu formulario' });
    }

    dispatch(setLoading());
    try {
      const thumbnail = await uploadThumbnailImageKit();
      const pdfs = await uploadPdfsToServer();
      
      await privateRequest.get('/auth/refresh');  // cambio

      const urls = [];
      for (const f of files) {
        const k = await uploadSingleVideo(f);
        urls.push(k);
      }

      const data = { ...courseData, urls, thumbnail, pdfs };
      if (urls.length && thumbnail) {
        const saved = await saveVideoInfo(data);
        // activar curso para tu usuario/test (mantengo tu userId de ejemplo)
        await dispatch(activateCourse({ courseIds:[saved._id], date: saved.createdAt, userId: '64cff3b67645a377b4f86dab' }));
        await getCourses();
      }
    } catch (err) {
      console.log(err);
    } finally {
      dispatch(resetLoading());
    }
  };

  return (
    <Container>
      <Wrapper>
        <Left>
          <div style={{ display:'flex', gap:'5vw' }}>
            <ThumbContainer>
              <ThumbnailLabel htmlFor='thumbFile'>
                <Thumbnail src={cover ? URL.createObjectURL(cover) : NonImage} alt='thumbnail' />
              </ThumbnailLabel>
              <ThumbnailInput id='thumbFile' type='file' onChange={onCoverChange} />
            </ThumbContainer>
          </div>

          <div style={{ flex:1 }}>
            <InputContainer>
              <Label>Título</Label>
              <Input type='text' name='title' onChange={onChange} />
            </InputContainer>
            <InputContainer>
              <Label>Descripción</Label>
              <Input type='text' name='description' onChange={onChange} />
            </InputContainer>
            <InputContainer>
              <Label>Duración Total (min.)</Label>
              <Input type='number' name='duration' onChange={onChange} />
            </InputContainer>
            <div style={{ display:'flex', gap:'20px' }}>
              <InputContainer>
                <Label>Precio ($)</Label>
                <Input type='number' name='price' onChange={onChange} placeholder='$' />
              </InputContainer>
              <InputContainer>
                <Label>Precio Dólares (USD)</Label>
                <Input type='number' name='dolarPrice' onChange={onChange} placeholder='u$s' />
              </InputContainer>
            </div>
          </div>
        </Left>

        <Right>
          {pdfFiles.length > 0
            ? <PdfsLabel htmlFor='pdffiles' style={{ background:'#e72020', color:'#fff' }}><PictureAsPdfIcon/> Agregar PDFs <CheckIcon style={{color:'#fff'}}/></PdfsLabel>
            : <PdfsLabel htmlFor='pdffiles'><PictureAsPdfIcon/> Agregar PDFs</PdfsLabel>
          }
          <AddPdfsButton id='pdffiles' type='file' multiple onChange={onPdfsChange} />

          {files.length < 15
            ? <AddVideoButton onClick={addInput}><VideoCallIcon/> Agregar Video</AddVideoButton>
            : <AddVideoButton disabled><VideoCallIcon/> Agregar Video</AddVideoButton>
          }

          <div style={{maxHeight:'70vh', overflowY:'auto', width:'100%'}}>
            {files.map((file, idx) => (
              <VideoInputContainer key={idx}>
                <Label htmlFor={`file${idx}`}>Seleccionar Video {idx + 1}</Label>
                <VideoInput id={`file${idx}`} type='file' accept='.mov,.avi,.mp4' onChange={(e) => onFileChange(e, idx)} />
                {files[idx] ? <div style={{position:'absolute', right:'1vw', top:'1vh'}}><CheckIcon style={{color:'green'}}/></div> : null}
              </VideoInputContainer>
            ))}
          </div>

          <UploadVideoButton onClick={handleCreateCourse}>CREAR CURSO</UploadVideoButton>
          {formError.set ? <p style={{color:'red', textAlign:'center'}}>{formError.message}</p> : null}
        </Right>
      </Wrapper>

      {/* panel derecho de preview simple */}
      <Wrapper2>
        <div style={{ margin:'8vh 2vw', width:'100%' }}>
          <h3 style={{ position:'sticky', top:0 }}>Cursos</h3>
          <div style={{ display:'flex', flexDirection:'column', gap:'10px', maxHeight:'60vh', overflowY:'auto' }}>
            {courses.map((c) => (
              <div key={c._id} style={{ display:'flex', alignItems:'center', gap:'10px', border:'1px solid #eee', borderRadius:8, padding:8 }}>
                <img src={c.thumbnail || NonImage} alt="" style={{ width:48, height:48, objectFit:'cover', borderRadius:6, border:'1px solid #ddd' }}/>
                <div style={{ fontWeight:500 }}>{c.title}</div>
              </div>
            ))}
          </div>
        </div>
      </Wrapper2>
    </Container>
  );
}